import axios from 'axios'
import { createApp } from 'vue'
import FButton from '~/js/components/button'
import { scroll } from '~/js/helpers/scroll'
import { Customer } from '~/js/models/customer'

const ID_CUSTOMER_ACCOUNT_INFO = 'js-customer-account-info'
document.addEventListener('DOMContentLoaded', () => {
  const elementCustomerAccountInfo = document.getElementById(
    ID_CUSTOMER_ACCOUNT_INFO
  )
  if (!elementCustomerAccountInfo) return

  const baseUrl = elementCustomerAccountInfo.dataset.baseUrl
  const acceptsMarketing =
    elementCustomerAccountInfo.dataset.acceptsMarketing == 'true'
  const {
    lastName,
    firstName,
    kanaFirstName,
    kanaLastName,
    customerId,
    hashedCustomerId,
  } = elementCustomerAccountInfo.dataset
  const metafields = JSON.parse(elementCustomerAccountInfo.dataset.metafields)

  const customer = new Customer({
    acceptsMarketing,
    firstName,
    lastName,
    kanaFirstName,
    kanaLastName,
    metafields,
  })

  createApp({
    name: 'TemplatesCustomersAccountInfo',
    data() {
      return {
        customer,
        errorMessages: {
          lastName: '',
          firstName: '',
          kanaLastName: '',
          kanaFirstName: '',
        },
        isProcessing: false,
        step: 0,
      }
    },
    components: {
      FButton,
    },
    computed: {
      isEditing() {
        return this.step === 1
      },
      isConfirm() {
        return this.step === 2
      },
      hasError() {
        return !!Object.values(this.errorMessages).filter((v) => v).length
      },
    },
    watch: {
      customer: {
        deep: true,
        handler() {
          if (Object.values(this.errorMessages).filter((v) => v).length)
            this.errorMessages = this.customer.getErrorMessages()
        },
      },
      step() {
        scroll()
      },
    },
    mounted() {
      this.$refs.form.style.display = 'block'
    },
    methods: {
      onBackToInfo() {
        this.step = 0
      },
      onBackToInput() {
        this.step = 1
      },
      onProceedToInput() {
        this.step = 1
      },
      onProceedToConfirm() {
        this.getError()
        if (!this.hasError) this.step = 2
      },
      getError() {
        this.errorMessages = this.customer.getErrorMessages()
      },
      async onSubmit() {
        this.getError()
        if (this.hasError) return

        this.isProcessing = true
        const [birthdayYear, birthdayMonth, birthdayDay] =
          this.customer.birthdayValue.split('-')
        try {
          await axios.post(`${baseUrl}/customers/update_customer`, {
            id: customerId,
            h: hashedCustomerId,
            acceptsMarketing: this.customer.acceptsMarketing,
            firstName: this.customer.firstName,
            lastName: this.customer.lastName,
            kanaFirstName: this.customer.kanaFirstName,
            kanaLastName: this.customer.kanaLastName,
            gender: this.customer.gender,
            birthdayYear,
            birthdayMonth,
            birthdayDay,
          })
          window.location.reload()
        } catch (error) {
          alert(
            '申し訳ございませんが、会員情報の更新にエラーが発生しました。しばらくしてからもう一度お試しください。'
          )
          this.errorMessage = error
          console.error(error)
        }
        this.isProcessing = false
      },
    },
  }).mount(elementCustomerAccountInfo)
})
